import _ from 'underscore';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { SimpleSummaryBar } from '@bingads-webui-campaign-react/summary-bar';

const Loader = (props) => {
  const {
    i18n,
    siteMap,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    breadCrumbText,
    backButtonText,
    backButtonUrl,
    updateAvailability,
    isVisible,
    ...others
  } = props;


  const selectedParent = _.findWhere(siteMap, { selected: true });

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });

  if (!isVisible) {
    return null;
  }

  return (<SimpleSummaryBar
    selectedParent={selectedParent}
    breadCrumbText={i18n.getString(_TL_('Property Center'))}
    backButtonText={backButtonText}
    backButtonUrl={backButtonUrl}
    {...others}
  />);
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  breadCrumbText: PropTypes.string,
  backButtonText: PropTypes.string,
  backButtonUrl: PropTypes.string,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

Loader.defaultProps = {
  breadCrumbText: null,
  backButtonText: null,
  backButtonUrl: null,
  updateAvailability: _.noop,
  isVisible: false,
};

export const HotelCenterV2SummaryBarLoader = React.memo(Loader);
